import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IGlobalMapObject } from '@api/types'
import { GlobalMapObjectFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        globalMapObject: IGlobalMapObject[]
      }
    }
  }
}

export default function globalMapObjects(): Promise<IGlobalMapObject[]> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { globalMapObject },
        },
      },
    }: Payload) => globalMapObject
  )
}

const query = gql`
  query globalMapObjects {
    viewer {
      company {
        globalMapObject {
          ...GlobalMapObjectFragment
        }
      }
    }
  }
  ${GlobalMapObjectFragment}
`
